import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { useTypedSelector } from "../../../../../../redux/store";
import { CellContentRoot } from "../../../../../LightTable";

const ClassCellContent: React.FC<ClassCellContent.Props> = ({ item }) => {
	const lang = useTypedSelector((state) => state.session.language);
	const content = useMemo(
		() => item.class?.name?.[lang] ?? "",
		[item.class?.name, lang],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ClassCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default ClassCellContent;
